exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1FrSclPkBso5Y667lfumnp {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n        -ms-flex-align: center;\n            align-items: center;\n    background: rgba(0, 0, 0, 0.8);\n    width: 100%;\n    height: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"container": "_1FrSclPkBso5Y667lfumnp"
};